var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6264 0 24 5.3736 24 12C24 18.6264 18.6264 24 12 24C5.3736 24 0 18.6264 0 12C0 5.3736 5.3736 0 12 0Z",
    fill: "#006AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5059 17.0592V7.0752H12.5931V17.0592H11.5059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0395 10.4016L13.6819 11.292L12.9331 7.80717L13.9315 7.58157L14.3251 9.23277C14.3251 9.23277 15.2323 7.74477 14.0227 6.20397C13.3099 5.41197 12.9715 5.37837 12.1723 5.25357C11.4691 5.15277 9.8347 5.39037 9.3475 7.29837C9.1411 8.52717 9.3739 9.43677 10.9579 10.6272L10.8691 11.952C10.8691 11.952 9.1003 10.7064 8.6443 9.83277C8.2915 9.14157 7.6867 7.77597 8.7787 5.87517C9.3667 4.92477 10.5259 4.01277 12.5683 4.10877C13.5955 4.15197 16.1035 5.40717 15.7147 8.33997C15.6475 8.88957 15.3619 9.62157 15.3619 9.62157L16.7395 9.31437L17.0395 10.4016Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1228 18.2135C14.5084 19.1471 13.3252 20.0279 11.2876 19.8791C10.2604 19.8095 7.78837 18.4871 8.25397 15.5663C8.33557 15.0191 8.64037 14.2967 8.64037 14.2967L7.25557 14.5655L6.98438 13.4735L10.366 12.6719L11.0236 16.1759L10.018 16.3751L9.66757 14.7119C9.66757 14.7119 8.72197 16.1735 9.88837 17.7479C10.5796 18.5591 10.9156 18.5999 11.7148 18.7463C12.4132 18.8663 14.0548 18.6695 14.5924 16.7759C14.83 15.5543 14.6212 14.6375 13.0708 13.4039L13.1956 12.0815C13.1956 12.0815 14.9308 13.3727 15.3628 14.2583C15.694 14.9615 16.2628 16.3439 15.1228 18.2135V18.2135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfi);
export default __webpack_public_path__ + "static/media/YFI.9c4c439356c546fc6a9774aaf98388cf.svg";
export { ForwardRef as ReactComponent };